import { Link } from "react-router-dom";

const NotFound = () => (
  <div className="p-10 text-center">
    <h1 className="title romanStandard text-sm">Page not found</h1>
    <p className="romanStandard pb-5">
      That page doesn’t exist. Try one of the links above.
    </p>
    <Link className="romanStandard underline" to="/">
      Back to the home page
    </Link>
  </div>
);

export default NotFound;
